module.exports = __webpack_public_path__ + "static/media/sync-black-18dp.5fdc7ceb.svg";